var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormContext } from "@/components/forms/FormContext";
import { FormCpf } from "@/components/forms/FormCpf";
import { FormRegister } from "@/components/forms/FormRegister";
import { Tabs as ShadTabs, TabsContent as ShadTabsContent, TabsList as ShadTabsList, TabsTrigger as ShadTabsTrigger, } from "@/components/ui/Tabs";
import { cn } from "@/lib/utils";
export function TabTrigger(_a) {
    var name = _a.name, value = _a.value;
    var loading = useFormContext().isLoading;
    return (_jsx(ShadTabsTrigger, __assign({ value: value, disabled: loading, className: "data-[state=active]:bg-primary-dark data-[state=active]:text-primary-dark-foreground" }, { children: name })));
}
export function TabsTriggers(_a) {
    var data = _a.data;
    return (_jsx(_Fragment, { children: data.map(function (trigger) { return (_jsx(TabTrigger, { name: trigger.name, value: trigger.value }, trigger.value)); }) }));
}
export function TabsRequest(_a) {
    var triggers = _a.triggers, tabChange = _a.tabChange;
    function onTabChange(value) {
        tabChange(value);
    }
    return (_jsxs(ShadTabs, __assign({ defaultValue: "cpf", className: "w-full max-w-[856px]", onValueChange: onTabChange }, { children: [_jsx(ShadTabsList, __assign({ className: cn("grid w-full grid-cols-2 px-5 bg-accent-light text-accent-light-foreground", "sm:max-w-[352px]") }, { children: _jsx(TabsTriggers, { data: triggers }) })), _jsx(ShadTabsContent, __assign({ value: "registerNumber" }, { children: _jsx(FormRegister, {}) })), _jsx(ShadTabsContent, __assign({ value: "cpf" }, { children: _jsx(FormCpf, {}) }))] })));
}
